import React from 'react';
import { Text, styled, TextAppearance } from '@vw-marketing/us-components';
import { Recall } from '../../../typings/general';
import NoRecall from './no-recall';
import RecallItem from './recall-item';

export const RecallSectionContainer: any = styled.div``;

interface RecallSectionProps {
  label: string;
  noFoundLabel: string;
  recalls?: Recall[];
  serviceDescription?: string;
}
const RecallSection = ({
  label,
  recalls,
  noFoundLabel,
  serviceDescription,
}: RecallSectionProps) => (
  <RecallSectionContainer>
    {recalls?.length ? (
      recalls.map((recall: Recall) => (
        <RecallItem
          key={recall.mfrRecallNumber}
          recall={recall}
          label={label}
          serviceDescription={serviceDescription}
        />
      ))
    ) : (
      <>
        <Text
          appearance={TextAppearance.copy0200}
          bold
          // style={{fontWeight: TextWeight.bold}}
        >
          {label} <br />
          <Text bold={false}>{serviceDescription}</Text>
        </Text>
        <NoRecall messageLabel={noFoundLabel} />
      </>
    )}
  </RecallSectionContainer>
);

export default RecallSection;
